import React from 'react';
import c from 'classnames';

import { SearchkitWrapper } from '@uncinc/react-searchkit';
import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';
import type { SearchSettingsConfig } from '@uncinc/react-searchkit/types';

import { requestOptions, runtimeMappings, sorting } from './config';
import { facetAttributes, resultAttributes } from '../SearchTopical/config';
import topicalRouting from '../SearchTopical/routing';

import {
  APP_OPTIONS,
  SEARCHKIT_HITS_PER_PAGE_TOPICAL,
  SEARCHKIT_HOST_URL,
} from '../../config/constants';

// Subcomponents.
import AdvancedFacets from '../SearchTopical/AdvancedFacets';
import Facets from '../SearchTopical/Facets';
import ResultsEvents from '../SearchTopical/Results/Events';

import '../SearchTopical/style.scss';

interface SearchTopicalEventsSubComponents {
  AdvancedFacets: typeof AdvancedFacets;
  Facets: typeof Facets;
  ResultsEvents: typeof ResultsEvents;
}

export interface SearchTopicalEventsProps extends Omit<SearchkitWrapperProps, 'connection' | 'searchSettings' | 'indexName'> {
  searchSettings?: Partial<SearchSettingsConfig>;
}

const SearchTopicalEvents: React.FC<SearchTopicalEventsProps>
& SearchTopicalEventsSubComponents = (props) => {
  const {
    className,
    children,
  } = props;

  const classNames = c('SearchTopical', className);

  return (
    <SearchkitWrapper
      className={classNames}
      connection={{
        host: SEARCHKIT_HOST_URL,
      }}
      routing={topicalRouting}
      indexName={APP_OPTIONS.parameters.searchkitIndexTopical}
      hitsPerPage={SEARCHKIT_HITS_PER_PAGE_TOPICAL}
      searchSettings={{
        search_attributes: [],
        result_attributes: resultAttributes,
        facet_attributes: facetAttributes,
        runtime_mappings: runtimeMappings,
        sorting,
      }}
      requestOptions={requestOptions}
    >
      { children }
    </SearchkitWrapper>
  );
};

SearchTopicalEvents.AdvancedFacets = AdvancedFacets;
SearchTopicalEvents.Facets = Facets;
SearchTopicalEvents.ResultsEvents = ResultsEvents;

export default SearchTopicalEvents;
